// Material-UI テーマ
import getMuiTheme from 'material-ui/styles/getMuiTheme'

export const darkColor = '#669966'
export const darkSecondaryColor = '#7986CB'

// どんなプロパティがあるかは ./node_modules/material_ui/styles/getMuiTheme.js を参照
export default function getMyMuiTheme() {
  var theme = getMuiTheme()
  // チェックボックスのチェックマーク
  theme.checkbox.checkedColor = darkColor
  // テキストフィールドのフォーカス時下線
  theme.textField.focusColor = darkColor
  theme.textField.hintColor = 'rgba(0,0,0,0.4)'
  theme.textField.floatingLabelColor = 'rgba(0,0,0,0.6)'
  // カレンダー
  theme.datePicker.color = darkColor
  theme.datePicker.selectColor = darkColor
  theme.datePicker.headerColor = darkColor
  // デフォルトボタン
  theme.flatButton.primaryTextColor = darkColor
  // ボタン
  theme.raisedButton.primaryColor = darkColor
  theme.raisedButton.secondaryColor = darkSecondaryColor

  return theme
}



// WEBPACK FOOTER //
// ./src/getMyMuiTheme.js